export default "__VITE_ASSET__D1Fr9CJ3__"